import { ThemeUICSSObject } from "theme-ui";
import { headingStyles } from "./headingStyles";
import { THeadingVariants } from "../theme";

export const defaultTextStyles: ThemeUICSSObject = {};

export const extraSmallTextStyles: ThemeUICSSObject = {
  fontSize: "xs",
  lineHeight: "tight",
  fontWeight: "thin",
  fontFamily: "paragraph",
  letterSpacing: "tight",
};

export const smallTextStyles: ThemeUICSSObject = {
  fontFamily: "paragraph",
  fontSize: "sm",
  fontWeight: "thin",
  lineHeight: "tight",
  letterSpacing: "tight",
};

export const mediumTextStyles: ThemeUICSSObject = {
  fontSize: "md",
  fontWeight: "thin",
  lineHeight: "tight",
  letterSpacing: "tight",
};

export const largeTextStyles: ThemeUICSSObject = {
  fontSize: "lg",
  fontWeight: "bold",
  lineHeight: "tighter",
  letterSpacing: "normal",
};

export const extraLargeTextStyles: ThemeUICSSObject = {
  fontSize: "xl",
  lineHeight: "tighter",
  fontWeight: "bold",
  letterSpacing: "normal",
};

export const caps: ThemeUICSSObject = {
  textTransform: "uppercase",
};

export enum TEXT_VARIANTS {
  xs = "xs",
  sm = "sm",
  default = "default",
  body = "body",
  md = "md",
  lg = "lg",
  xl = "xl",
  caps = "caps",
}

export const textStyles: Record<
  TEXT_VARIANTS | THeadingVariants,
  ThemeUICSSObject
> = {
  default: defaultTextStyles,
  xs: extraSmallTextStyles,
  sm: smallTextStyles,
  body: defaultTextStyles,
  md: mediumTextStyles,
  lg: largeTextStyles,
  xl: extraLargeTextStyles,
  caps: caps,
  ...headingStyles,
};
